// extracted by mini-css-extract-plugin
module.exports = {"shipLevelName":"ClassNationHistoryTable_shipLevelName_2agTX","shipLevel":"ClassNationHistoryTable_shipLevel_u3mzG"};